import { type FC, useContext } from "react"

import type { BaseCommunityFragment } from "../../generated/graphql"
import { UserContext } from "../../providers/UserProvider"
import { useCommunityCustomization } from "../../utils/useCommunityCustomization"
import { MaskedIcon } from "../icons/MaskedIcon"
import { ModalBase } from "../ModalBase"
import UbiqButton, { UbiqButtonSize, UbiqButtonType } from "../UbiqButton"

const SUBMITTED_MODAL_PANEL_STYLES =
  "w-[calc(100vw-32px)] pt-12 px-6 pb-10 font-mono sm:max-w-[480px] sm:px-[54px] flex flex-col items-center"

const LINK_BUTTON_STYLES = "cursor-pointer underline appearance-none border-0 bg-transparent p-0"

interface SubmittedProps {
  communityToJoin: BaseCommunityFragment | null
  onLogout: () => void
  modalViewportStyles: string
  modalContainerStyles: string
  modalPanelStyles: string
}

export const Submitted: FC<SubmittedProps> = ({
  communityToJoin,
  onLogout,
  modalViewportStyles,
  modalContainerStyles,
  modalPanelStyles,
}) => {
  const customizationData = useCommunityCustomization()
  const { user } = useContext(UserContext)

  if (!customizationData) return null
  const modalWindowStyles = customizationData.styles.global.modalWindow
  const communityName = communityToJoin?.name ?? customizationData.name
  const logoSrc = customizationData.styles.global.logo.src || communityToJoin?.iconUrl
  const accountLabel = user?.username
    ? `@${user.username}`
    : user?.email
      ? user.email
      : "your account"

  return (
    <ModalBase
      dialogContainerStyles={modalContainerStyles}
      dialogPanelStyles={`${SUBMITTED_MODAL_PANEL_STYLES} ${modalWindowStyles.container} ${modalPanelStyles}`}
      dialogViewportStyles={modalViewportStyles}
      show
    >
      {logoSrc && <MaskedIcon additionalStyle="mx-auto mb-6 block" src={logoSrc} width={96} />}
      <h2 className={`mb-4 text-center text-primary-h2 ${modalWindowStyles.title}`}>
        {communityName}
      </h2>
      <p className={`mb-8 text-center text-body-lg text-textPrimary ${modalWindowStyles.subtitle}`}>
        You have requested to join
        <br /> {communityName} on WERZ.
      </p>

      <UbiqButton
        buttonType={UbiqButtonType.LIGHT}
        disabled={true}
        size={UbiqButtonSize.MEDIUM}
        styles="!w-[220px]"
        title="REQUESTED"
        type="button"
      />

      <p className="mt-6 text-center text-body-md text-textPrimary">
        You are logged in as {accountLabel}{" "}
        <button className={LINK_BUTTON_STYLES} onClick={onLogout} type="button">
          log out
        </button>
      </p>
    </ModalBase>
  )
}
